import { createContext, FC, PropsWithChildren, useCallback, useState } from 'react';
import { useMount } from 'react-use';
import { useLocation } from 'react-router-dom';

import { useRouter } from '@cvt/routing';

import { ContextProps, Step } from './OnboardingWizardContext.types';


const STEPS: Step[] = ['objectives', 'values', 'story'];

export const defaultContext: ContextProps = {
  currentStep: 'objectives',
  steps: STEPS,
  setCurrentStep: () => {},
  onNextStep: () => {},
  onPreviousStep: () => {},
  currentStepIndex: 0,
  setData: () => {},
  data: {
    preferences: {
      communicationObjective1: '',
      communicationObjective2: '',
      communicationObjective3: '',
      leadershipValue1: '',
      leadershipValue2: '',
      leadershipValue3: '',
    },
    story: '',
  },
};

export const OnboardingWizardContext = createContext(defaultContext);

type Props = {
};

export const OnboardingWizardProvider: FC<PropsWithChildren<Props>> = (props) => {
  const { children } = props;
  const router = useRouter();
  const { pathname } = useLocation();

  const [currentStep, setCurrentStep] = useState<Step>(defaultContext.currentStep);
  const [data, setData] = useState<ContextProps['data']>(defaultContext.data);


  const onNextStep = useCallback(() => {
    const currentIndex = STEPS.indexOf(currentStep);
    if (currentIndex < STEPS.length - 1) {
      setCurrentStep(STEPS[currentIndex + 1]);
      router.onboarding[STEPS[currentIndex + 1]].go();
    }

  }, [currentStep, router.onboarding]);

  const onPreviousStep = useCallback(() => {
    const currentIndex = STEPS.indexOf(currentStep);
    if (currentIndex > 0) {
      setCurrentStep(STEPS[currentIndex - 1]);
      router.onboarding[STEPS[currentIndex - 1]].go();
    }
  }, [currentStep, router.onboarding]);

  useMount(() => {
    const currentRouteIndex = STEPS.findIndex((step) => pathname.includes(step));
    if (currentRouteIndex !== -1) {
      setCurrentStep(STEPS[currentRouteIndex]);
    }
  });

  return (
    <OnboardingWizardContext.Provider
      value={{
        currentStep,
        steps: STEPS,
        setCurrentStep,
        currentStepIndex: STEPS.indexOf(currentStep),
        onNextStep,
        onPreviousStep,
        setData,
        data,
      }}
    >
      {children}
    </OnboardingWizardContext.Provider>
  );
};

export const OnboardingWizardConsumer = OnboardingWizardContext.Consumer;
